import axios from 'axios';
import { VisasqNowQuestionDraft } from '@/types';
import { userSession } from '@/utils/userSession';

// /api/v1/visasq/visasq_now/question_drafts
export const visasqNowQuestionDraft = async (request_id: string) => {
  const { data } = await axios.post<VisasqNowQuestionDraft>(
    '/visasq/visasq_now/question_drafts',
    {
      request_id,
      user_id: userSession.getUserId(),
    },
  );

  return data;
};
